import React, { Component } from 'react';
export default class Portfolio extends Component {
    render() {
      return (
        <React.Fragment>
        {/*generated code*/}
                <section id="portfolio">
                <div className="row section-intro">
                <div className="col-twelve">
                    <h5>Portfolio</h5>
                    <h1>Check Out Some of My Works.</h1>
                    <p className="lead">Recently, I have discovered a great Zeal to make Things happen and I am in my learning phase would Like to share my Attempts towards a possible path to substantial growth. Hope yoy'll see and guide me to ease that path.</p>
                </div>   		
                </div> {/* /section-intro*/} 
                <div className="row portfolio-content">
                <div className="col-twelve">
                    {/* portfolio-wrapper */}
                    <div id="folio-wrapper" className="block-1-2 block-mob-full stack">
                    <div className="bgrid folio-item">
                        <div className="item-wrap">
                        <img src="images/portfolio/liberty.jpg" alt="Liberty" />
                        <a href="#modal-01" className="overlay">	                  	           
                            <div className="folio-item-table">
                            <div className="folio-item-cell">
                                <h3 className="folio-title">NickBee</h3>	     					    
                                <span className="folio-types">
                                System App [NaN]
                                </span>
                                <p>Automated Desktop wallpaper to change Colors in sync with the Colors of Keyboard.<br/>
                                <br/>Illusion: Desktop and Keyboard are in sync.</p>
                            </div>	                      	
                            </div>                    
                        </a>
                        </div>	               
                    </div> {/* /folio-item */}
                    <div className="bgrid folio-item">
                        <div className="item-wrap">
                        <img src="images/portfolio/salad.jpg" alt="Salad" />
                        <a href="#modal-06" className="overlay">
                            <div className="folio-item-table">
                            <div className="folio-item-cell">
                                <h3 className="folio-title">Stock Market Prediction</h3>	     					    
                                <span className="folio-types">
                                Predictive Analysis [2020]
                                </span>
                                <p>This was built to analyse the Stock Market share Data and Predict the possible Market Curve to help bid on the Market.<br/>
                                <br/>Asknbid assignment</p>		     		
                            </div>	                      	
                            </div>                    
                        </a>
                        </div>
                    </div> {/* /folio-item */}
                    <div className="bgrid folio-item">
                        <div className="item-wrap">
                        <img src="images/portfolio/lighthouse.jpg" alt="Lighthouse" />
                        <a href="#modal-05" className="overlay">             		                  
                            <div className="folio-item-table">
                            <div className="folio-item-cell">
                                <h3 className="folio-title">Biomeditates</h3>	     					    
                                <span className="folio-types">
                                Machine Learning [2020]
                                </span>		
                                <p>Developed to analyse the .dicom images captured during an MRI scan and use Data Analysis and MATLAb to find the possible tumour<br/>
                                <br/>MRI images</p>     		
                            </div> 	                      	
                            </div>                    
                        </a>
                        </div>
                    </div> {/* /folio-item */}
                    
                    <div className="bgrid folio-item">
                        <div className="item-wrap">
                        <img src="images/portfolio/clouds.jpg" alt="Clouds" />
                        <a href="#modal-03" className="overlay">             		                  
                            <div className="folio-item-table">
                            <div className="folio-item-cell">
                                <h3 className="folio-title">ToDoList</h3>	     					    
                                <span className="folio-types">
                                Web App [2020]
                                </span>
                                <p>Developed a ToDo list app so that users can track daily tasks and get going with simple yet uniques UI style.<br/>
                                <br/> Deployed on Zeeit.now</p>		     		
                            </div> 	                      	
                            </div>                    
                        </a>
                        </div>
                    </div> {/* /folio-item */}
                    
                    <div className="bgrid folio-item">
                        <div className="item-wrap">
                        <img src="images/portfolio/shutterbug.jpg" alt="Shutterbug" />
                        <a href="#modal-02" className="overlay">              		                  
                            <div className="folio-item-table">
                            <div className="folio-item-cell">
                                <h3 className="folio-title">Wachowski</h3>	     					    
                                <span className="folio-types">
                                Chat Bot [2019]
                                </span>
                                <p>A two way chatbot system listening to both end users issues and suggesting measures to resolve it.<br/>
                                <br/>python ML/DeepLearning</p>		     		
                            </div> 	                      	
                            </div>                    
                        </a>
                        </div>
                    </div> {/* /folio-item */}
                    <div className="bgrid folio-item">
                        <div className="item-wrap">
                        <img src="images/portfolio/beetle.jpg" alt="Beetle" />
                        <a href="#modal-04" className="overlay">                  	                 
                            <div className="folio-item-table">
                            <div className="folio-item-cell">
                                <h3 className="folio-title">DOM Bakery</h3>	     					    
                                <span className="folio-types">
                                Web App [2020]
                                </span>
                                <p>Developed to soothen all the sweettooth as we aren't so sure to eat outside lets gaze them. With an Added Dark Mode flavour<br/>
                                <br/> Prototype: Vanilla.js</p>		     		
                            </div>  	                      	
                            </div>                    
                        </a>
                        </div>
                    </div> {/* /folio-item */}     
                    </div> {/* /portfolio-wrapper */} 
                </div>  {/* /twelve */}   
                </div> {/* /portfolio-content */} 
            </section> {/* /portfolio */}
        </React.Fragment>
      );
    }
  }